import React from 'react';
import InputSaleItem from '../../../components/InputSaleItem'
import {data1, data2} from "../CardForm/formStructure";
import {toast} from "react-toastify";
import { sessionStorageGet, sessionStorageSet } from '../../../lib/window-shim';

/**
 * CategoryCard component.
 *
 * Displays listing options for the item listing page:
 * - Auction toggle checkbox (from data1)
 * - Other category options (from data2) - currently unused due to condition bug
 *
 * Controls whether the listing is an auction (with duration) or fixed price.
 * Shows toast notifications on toggle change.
 *
 * @param {Object} props - Component props
 * @param {Function} props.setIsAuction - Callback to set auction mode (true/false)
 * @returns {React.ReactElement} Listing options card
 */
const CategoryCard = ({setIsAuction}) => {

    /**
     * Handles changes from the input checkboxes.
     * @param {React.ChangeEvent<HTMLInputElement>} e - The input change event.
     * @param {string} text - The label text of the checkbox (e.g., "Auction").
     * @param {string} id - The ID of the checkbox (e.g., "isAuction").
     */
    const change = (e, text, id) => {
        const isChecked = e.target.checked;

        // We only care about the "Auction" checkbox for now.
        if (id === 'isAuction') {
            // Call the function passed from the parent to update the state.
            // This will control whether the auction duration fields are shown.
            setIsAuction(isChecked);

            // Update the placeholder text for the price input based on the selection.
            const formData = JSON.parse(sessionStorageGet("formFields") ?? 'null');
            if (formData) {
                formData[0].PlaceHolder = isChecked
                    ? 'Reserve Amount in [COIN]'
                    : 'Sale Price in [COIN]';
                sessionStorageSet("formFields", JSON.stringify(formData));
            }

            toast(`${text} is ${isChecked ? 'enabled' : 'disabled'}`);
        }
    }

    return (
        <div className="card card-purple h-100 mb-30">
            <div className="card-header pb-0 p-3">
                <h6 className="mb-0 text-light">Listing Options</h6>
            </div>
            <div className="card-body p-3">

                <ul className="list-group">
  {data1 && data1.map((item, i) =>
    condition ? (
      <InputSaleItem
        key={i}
        id={item.id}
        checked={item.checked}
        text={item.text}
        hide={item.hide}
        onChange={event => change(event, item.text, item.id)}
      />
    ) : null
  )}
</ul>

            </div>
        </div>
    );
}

export default CategoryCard;
